import { render, staticRenderFns } from "./Texttoolbar.vue?vue&type=template&id=30c0d020&scoped=true&"
import script from "./Texttoolbar.vue?vue&type=script&lang=js&"
export * from "./Texttoolbar.vue?vue&type=script&lang=js&"
import style0 from "./Texttoolbar.vue?vue&type=style&index=0&id=30c0d020&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c0d020",
  null
  
)

export default component.exports